import { render, staticRenderFns } from "./template-management.vue?vue&type=template&id=0368d2c8&"
import script from "./template-management.vue?vue&type=script&lang=ts&"
export * from "./template-management.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports